﻿

(() => {
    angular.module("fliptoWeb")
        .animation(".view-animate", [
            () => {
                return {
                    enter: (element, done) => {
                        done();
                        return (cancelled) => {
                            //this (optional) function will be called when the animation
                            //completes or when the animation is cancelled (the cancelled
                            //flag will be set to true if cancelled).
                        }
                    },

                    leave: (element, done) => {
                        window.scrollTo(0, 0);
                        done();
                        return (cancelled) => {
                            //this (optional) function will be called when the animation
                            //completes or when the animation is cancelled (the cancelled
                            //flag will be set to true if cancelled).
                        }
                    }
                }
            }
        ]);
})()
